module.exports = __webpack_public_path__ + "img/48.dc2c9b0a.png";